export const VIEW_MODE_VALUES = ['grid', 'collection'] as const;
export type ViewModeToggleValue = (typeof VIEW_MODE_VALUES)[number];

export type ViewModeTogglePropsMicrocopy = {
  ariaLabel: string;
  grid: string;
  collection: string;
};

export type ViewModeTogglePropsData = {
  value: ViewModeToggleValue;
};

export type ViewModeTogglePropsDataWithMicrocopy = ViewModeTogglePropsData & {
  microcopy: ViewModeTogglePropsMicrocopy;
};

export type ViewModeTogglePropsActions = {
  onValueChange: (value: ViewModeToggleValue) => void;
};

export type ViewModeToggleProps = ViewModeTogglePropsDataWithMicrocopy &
  ViewModeTogglePropsActions & {
    className?: string;
  };
